import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { authService } from "../services/authService";
import { UserContextError } from "../types";

export interface AuthState {
  authenticated: boolean;
  authenticating: boolean;
  user: any | null;
  errors: UserContextError[];
  token: string | null;
  csrfToken: string | null;
}

const initialState: AuthState = {
  authenticated: !!authService.getAccessToken(),
  authenticating: false,
  user: authService.getUser(),
  errors: [],
  token: authService.getAccessToken(),
  csrfToken: authService.getCsrfToken(),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthenticating: (state, action: PayloadAction<boolean>) => {
      state.authenticating = action.payload;
    },
    setAuthenticated: (
      state,
      action: PayloadAction<{ user: any; token: string; csrfToken?: string | null }>,
    ) => {
      state.authenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.csrfToken = action.payload.csrfToken || null;
      state.authenticating = false;
      state.errors = [];
    },
    setAuthErrors: (state, action: PayloadAction<UserContextError[]>) => {
      state.errors = action.payload;
      state.authenticating = false;
    },
    setUser: (state, action: PayloadAction<any | null>) => {
      state.user = action.payload;
    },
    logout: state => {
      state.authenticated = false;
      state.user = null;
      state.token = null;
      state.csrfToken = null;
      state.errors = [];
    },
  },
});

export const { setAuthenticating, setAuthenticated, setAuthErrors, setUser, logout } =
  authSlice.actions;
export default authSlice.reducer;
